// extracted by mini-css-extract-plugin
module.exports = {"programChip":"_-_-pharmacy-src-program-programChip-programChip__programChip--3DvXk"};